import styled from "styled-components"

export const GanttChartContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 40px 1fr;
  grid-gap: 5px;
`

export const GanttBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  grid-gap: 1rem;
  overflow: auto;
  padding-right: 10px;
`

export const HeaderGantt = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  grid-template-columns: ${({ nbColumns }) => `50% repeat(${nbColumns}, 1fr)`};
  grid-gap: 2px;
  padding-right: 20px;
  .cellCol {
    color: ${({ color }) => color || "#7b3063"};
    background: ${({ background }) => background || "#e2e1e1"};
    width: 90%;
    height: 35px;
    margin-left: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 5px;
    font-size: 0.8rem;
    border-radius: 2px;
  }
`

export const RowGanttContainer = styled.div`
  position: relative;
  background: #fff;
  height: 100px;
  margin-left: 30px;
  width: calc(100% - 30px);
  .row {
    height: 100px;
    width: ${({ width }) => (width ? `calc(${width}% - 20px)` : "50%")};
    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 8px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    .labelStepContainer {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.8rem;
      font-weight: bold;
      background: #e2e1e1;
      width: 70px;
      height: 40px;
      top: 30px;
      left: -30px;
      border-radius: 5px;
    }
  }

  .infosGlobal {
    width: 50%;
    height: 100%;
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    padding: 8px 8px 8px 45px;
    font-size: 0.75rem;
    position: absolute;
    top: 0;
    .etiquetteName {
      background: #9ee1de;
      width: fit-content;
      height: fit-content;
      border-radius: 5px;
      margin-right: 5px;
      font-size: 0.6rem;
      padding: 5px;
    }
    .infosLeft {
      display: grid;
      grid-template-rows: 1fr 1fr 1fr;
      border-right: 1px solid #d1d1d1;
      .nameRow {
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        .name {
          font-weight: bold;
          margin-left: 13px;
        }
      }
      .timming {
        display: grid;
        grid-template-columns: 1fr auto;
        grid-gap: 5px;
        align-items: center;
        margin-left: 13px;
        span {
          margin-left: 2px;
          font-weight: bold;
        }
        .delay {
          color: #f31606;
        }
        .button {
          font-size: 0.6rem;
          padding: 5px;
          background: ${({ isDelay }) => (isDelay ? "#F31606" : "#7b3063")};
          border-radius: 5px;
          color: #fff;
          margin-right: 5px;
        }
      }
    }
    .infosRight {
      display: grid;
      grid-template-rows: 1fr 1fr 1fr;
      padding-left: 5px;
      .nameUser {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .step {
      display: grid;
      grid-template-columns: 1fr auto;
      grid-gap: 5px;
      align-items: center;
      .stepName {
        display: flex;
        align-items: center;
      }
    }
    .marker {
      width: 8px;
      height: 25px;
      background: ${({ colorMarker }) => colorMarker || "#e2e1e1"};
      border-radius: 5px;
      margin-right: 5px;
    }
  }
`

export const ColStep = styled.div`
  height: 100px;
  width: ${({ widthStep }) => `calc(${widthStep}% - 20px)` || "100%"};
  margin-left: 20px;
  position: absolute;
  top: 0;
  left: ${({ postionStep }) => `calc(${postionStep}% - 20px)` || "50%"};
  padding: 15px 5px;
  display: grid;
  grid-template-columns: ${({ isCompleted }) => (isCompleted ? `1fr` : `repeat(5, 1fr)`)};
  align-items: ${({ isCompleted }) => (isCompleted ? "center" : "start")};
  .done {
    background: #3a8125;
  }
  .inProgress {
    background: ${({ colorMarker }) => colorMarker || "#e2e1e1"};
  }
  .todo {
    background: #e2e1e1;
  }
  .isCompleted {
    width: 90%;
    margin-left: 5%;
  }
`

export const RowStep = styled.div`
  border-radius: 10px;
  height: 10px;
  margin-top: ${({ rowStep }) => `calc(${rowStep} * 15px)`};
`

export const Marker = styled.div`
  width: 8px;
  height: 25px;
  background: ${({ colorMarker }) => colorMarker || "#e2e1e1"};
  border-radius: 5px;
  margin-right: 5px;
`
